import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExposureNeg1Icon(props: IconProps) {
    return <Icon {...props} iconKey={"exposure_neg_1"}/>
}
